import { render, staticRenderFns } from "./dashboard.page.vue?vue&type=template&id=0283a70e&scoped=true&"
import script from "./dashboard.page.vue?vue&type=script&lang=js&"
export * from "./dashboard.page.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.page.vue?vue&type=style&index=0&id=0283a70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0283a70e",
  null
  
)

export default component.exports